import { useEffect } from 'react'
import { useSponsorContext } from '../context/sponsor/SponsorProvider'
import useSponsorsActions from '../hooks/useSponsorsActions'
import { useParams } from 'react-router-dom'
import Breadcrumb from '../../core/components/UI/Breadcrumb'
import ImageInput from '../../core/components/UI/ImageInput'
import SponsorDetails from '../components/sponsors-detail-page/SponsorDetails'
import LoaderSponsorDetails from '../components/sponsors-page/LoaderSponsorDetails'

export default function SponsorDetailsPage() {
  const { sponsor_id } = useParams()
  const { sponsorState } = useSponsorContext()
  const { getSponsor } = useSponsorsActions()
  
  useEffect(() => {
    getSponsor(sponsor_id)
  }, [sponsor_id])
  const links = [
    {
      id: 1,
      label: 'الرعاة',
      isActive: true,
      to: `/sponsors`,
    },
    {
      id: 2,
      label:sponsorState.sponsor?.name_ar,
      isActive: true,
      to: `/sponsor/${sponsor_id}`,
    },
  ]
  
  return (
    <>
      <Breadcrumb links={links} />

      {sponsorState?.isLoading ? (
        <LoaderSponsorDetails />
      ) : (
        <SponsorDetails sponsor={sponsorState?.sponsor} />
      )}
    </>
  )
}
